import { createRecipe } from './runtime.js';

const carouselDotConfig = {"name":"carouselDot","className":"carousel-dot","defaultVariants":{"selected":false},"variantMap":{"selected":["false","true"]}}

export const carouselDot = /* @__PURE__ */ createRecipe(carouselDotConfig)